import apiClient from '@u/apiClient'
import GetLocationListController from '@/wayfinder/actions/App/Http/Controllers/SquareUp/GetLocationListController'
import AddLocalSiteToLocationsController from '@/wayfinder/actions/App/Http/Controllers/SquareUp/AddLocalSiteToLocationsController'

export default {
  getSquareUpLocations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetLocationListController.get({ site: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addSiteToSquareUpLocations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(AddLocalSiteToLocationsController.get({ site: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
